import { createAction } from '@lingoda/core';

export default createAction('booking/GET_LEAD_TIME');
